import Image, { ImageProps } from 'next/image';
import Link from 'next/link';

export type LogoProps = Pick<ImageProps, 'height' | 'width'> & {
  variant: 'color' | 'white' | 'icon';
  className?: string;
  alt?: string;
  customerCode?: string;
  src?: string;
  linked?: boolean;
};

const logoVariant: Record<LogoProps['variant'], string> = {
  color: '/Images/logo/logo.png',
  white: '/Images/logo/logo-white.png',
  icon: '/Images/logo/logo-icon.png',
};

export default function Logo({
  variant,
  className,
  width = 125,
  height = 40,
  alt = 'Academy suite Logo',
  src,
  linked = true,
}: LogoProps) {
  const image = (
    <Image
      src={src ? src : logoVariant[variant]}
      alt={alt}
      className="h-auto w-auto max-h-12"
      width={width}
      height={height}
    />
  );

  if (!linked) {
    return <span className={className}>{image}</span>;
  }

  return (
    <Link className={className} href="/">
      {image}
    </Link>
  );
}
